import { useEffect } from "react";

import { convertTimestampToDateNumber, getEndOfYearSeasonalVariant } from "@simplyk/common";
import { enqueueSnackbar } from "notistack";

import { AmplitudeEvents } from "../../../../../common/constants/amplitude";
import { useCurrentUserContext } from "../../../../../common/contexts/CurrentUserContext";
import { trpc } from "../../../../../common/helpers/trpc";
import { useLiveFormAmplitudeEvents } from "../../common/amplitude/useLiveFormAmplitudeEvents";
import { useLiveFormEditorContext } from "../../common/LiveFormEditorContext";

import { useEndOfYearChecklistEntryPoint } from "@/common/hooks/useEndOfYearChecklistEntryPoint";

export const useActivateDonationForm = () => {
  const {
    apiFormObject: apiDonationForm,
    updateApiFormObject,
    isOnboarding,
  } = useLiveFormEditorContext<"donation-form">();
  const { organization } = useCurrentUserContext();
  const { logUserActionEvent } = useLiveFormAmplitudeEvents();
  const activateDonationFormMutation = trpc.activateDonationForm.useMutation();
  const endOfYearChecklistEntryPoint = useEndOfYearChecklistEntryPoint();

  const status = apiDonationForm.status;

  useEffect(() => {
    const activateDonationForm = async () => {
      if (status === "draft") {
        logUserActionEvent(AmplitudeEvents.FormCreated, {
          organization_creation_date: organization?.createdAtUtc
            ? convertTimestampToDateNumber(organization.createdAtUtc)
            : null,
          ...(endOfYearChecklistEntryPoint && {
            entry_point: endOfYearChecklistEntryPoint,
            seasonal_variant: organization?.country ? getEndOfYearSeasonalVariant(organization.country) : null,
          }),
        });
        const { data: updatedDonationFormResult, error } = await activateDonationFormMutation.mutateAsync({
          donationFormId: apiDonationForm.id,
          isOnboarding,
        });

        if (error) {
          enqueueSnackbar(error?.message, {
            vibe: "danger",
          });
          return;
        }

        if (updatedDonationFormResult) {
          updateApiFormObject({
            ...apiDonationForm,
            path: updatedDonationFormResult.path,
            status: updatedDonationFormResult.status,
          });
        }
      }
    };

    activateDonationForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiDonationForm.id]); // We voluntarily activate only if id change (and not status)
};
